import { OsType, getOSType } from '@/util/device';

let isSensor: boolean = false;
let accx: number = 0;
let accy: number = 0;
let accz: number = 0;
let aigx: number = 0;
let aigy: number = 0;
let aigz: number = 0;
let rotr: number = 0;
let rotp: number = 0;
let roty: number = 0;

function handlerDeviceMotion(event: DeviceMotionEvent): void {
  const sign: number = getOSType() === OsType.iOS || getOSType() === OsType.iPad ? -1 : 1;
  isSensor = true;
  accx = (Math.round((event.acceleration?.x ?? 0) * 100) / 100) * sign;
  accy = (Math.round((event.acceleration?.y ?? 0) * 100) / 100) * sign;
  accz = (Math.round((event.acceleration?.z ?? 0) * 100) / 100) * sign;
  aigx = (Math.round((event.accelerationIncludingGravity?.x ?? 0) * 100) / 100) * sign;
  aigy = (Math.round((event.accelerationIncludingGravity?.y ?? 0) * 100) / 100) * sign;
  aigz = (Math.round((event.accelerationIncludingGravity?.z ?? 0) * 100) / 100) * sign;
  // rotr = Math.round((event.rotationRate?.alpha ?? 0) * 100) / 100;
  // rotp = Math.round((event.rotationRate?.beta ?? 0) * 100) / 100;
  // roty = Math.round((event.rotationRate?.gamma ?? 0) * 100) / 100;
}

function handlerDeviceOrientation(event: DeviceOrientationEvent): void {
  isSensor = true;
  rotr = Math.round((event.alpha ?? 0) * 100) / 100;
  rotp = Math.round((event.beta ?? 0) * 100) / 100;
  roty = Math.round((event.gamma ?? 0) * 100) / 100;
}

export function sensorStart(): void {
  window.addEventListener('devicemotion', handlerDeviceMotion);
  window.addEventListener('deviceorientation', handlerDeviceOrientation);
}

export function sensorStop(): void {
  window.removeEventListener('devicemotion', handlerDeviceMotion);
  window.removeEventListener('deviceorientation', handlerDeviceOrientation);
}

export function getIsSensor(): boolean {
  return isSensor;
}

export function getSensorAcc(): [number, number, number] {
  return [accx, accy, accz];
}

export function getSensorAig(): [number, number, number] {
  return [aigx, aigy, aigz];
}

export function getSensorRot(): [number, number, number] {
  return [rotr, rotp, roty];
}
